/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNjY3NSAzLjY3NzE4TDguMzY1IDNMMTMgNy41TDguMzY1IDEyTDcuNjY3NSAxMS4zMjI4TDExLjExIDcuOTgwNThIMVY3LjAxOTQySDExLjExTDcuNjY3NSAzLjY3NzE4WiIgZmlsbD0iIzdGN0Y3RiIvPjwvc3ZnPg==";